<template>
  <div class="orderContent">
    <p class="message">
      {{ $t('Order_to_be_paid_message') }}
    </p>
    <div v-if="currentOrder">
      <SfButton class="sf-button--text all-orders" @click="resetCurrentOrder">
        {{ $t('All_Payment_orders') }}
      </SfButton>
      <OrderInfo :prePayOrder="currentOrder" />
    </div>
    <div v-else>
      <div v-if="totalOrders === 0" class="no-orders">
        <p class="no-orders__title">{{ $t('order_payment_list_null') }}</p>
      </div>
      <div v-else>
        <List v-if="orders && orders && orders.length" :list="orders"
              @back="setCurrentOrder" type="ToBePaid" @cancelOrder="handleCancel" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import { usePrePayList, useOrderClose } from '@bee-hole/coms';
import List from '~/components/Order/OrderList';
import OrderInfo from '~/components/Order/OrderInfo';
import Paginate from '~/components/Paginate';
export default {
  name: 'OrderPaymentTab',
  components: {
    SfButton,
    List,
    OrderInfo,
    Paginate
  },
  setup(props, context) {
    const { root, emit } = context;
    const orders = ref([]);
    const totalOrders = ref(0);
    const currentOrder = ref(null);
    const queryParams = ref({ page_no: 1, page_size: 10 });
    const { getPrePayList, prepaylist } = usePrePayList('ToBePaid');
    const cancelOrderData = ref(null);
    const { closeOrder, result: cancelRes } = useOrderClose();
    // const { orderLists, orderGet, total } = useOrder();

    const totalPageNo = computed(() => {
      return Math.ceil(totalOrders.value / queryParams.value.page_size) || 1;
    });

    const loadOrders = async () => {
      await getPrePayList();
      orders.value = prepaylist.value?.list;
      totalOrders.value = prepaylist.value?.list?.length || 0;
      // totalOrders.value = total.value;
    };

    const handlePageChange = async (page) => {
      queryParams.value.page_no = page;
      await loadOrders();
    };

    const setCurrentOrder = (order) => {
      currentOrder.value = order;
    };

    const resetCurrentOrder = () => {
      currentOrder.value = null;
    };
    const handleCancel = async (order) => {
      emit('cancelSuccess', order);
    };
    const cancelSuccess = async ()=> {
      console.log('cancelSuccess');
      loadOrders();
    }
    onMounted(async () => {
      await loadOrders();
    });

    return {
      orders,
      totalOrders,
      currentOrder,
      queryParams,
      totalPageNo,
      loadOrders,
      handlePageChange,
      setCurrentOrder,
      resetCurrentOrder,
      handleCancel,
      cancelSuccess
    };
  }
};
</script>

<style lang="scss" scoped>
.orderContent {
  margin: 0 auto;
  max-width: 1240px;
  padding: 0 var(--spacer-sm);
  
  @include for-desktop {
    padding: 0;
  }
}

.message {
  margin: 0 0 var(--spacer-xl) 0;
  font-size: var(--font-size--base);
}

.no-orders {
  &__title {
    margin: 0 0 var(--spacer-xl) 0;
    font-size: var(--font-size--base);
  }
}

.all-orders {
  --button-padding: var(--spacer-base) 0;
}

.orderPaginteItem {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
</style>
